import React, { Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { routesConfig } from "./routesConfig";
import Loader from "../components/loader-spinner/Loader";

function AnimatedRoutes() {
    const location = useLocation();

    return (
        <Suspense fallback={<Loader isVisible={true} />}>
            <Routes
                location={location} 
                key={location.pathname}
            >
                {routesConfig.map(({ path, element }) => (
                    <Route
                        key={path}
                        path={path}
                        element={element}
                    />
                ))}
            </Routes>
        </Suspense>
    );
}

export default AnimatedRoutes;
